import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
// eslint-disable-next-line @dhl/generic/no-restricted-imports -- Use sx props or styled components to create CSS
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()({
  '@keyframes move': {
    '0%, 45%': {
      to: {
        transform: 'translate(0,0)}',
      },
    },
    '20%, 25%': {
      transform: 'translate(100px,-20px)',
    },
  },
  animation: {
    transform: 'translate(0,0)',
    animation: '$move 10s .3s ease infinite',
  },
  st0: {
    enableBackground: 'new 0 0 753.3 518.3',
    xmlSpace: 'preserve',
    width: '100%',
    height: 'auto',
    maxWidth: '753.3px',
    maxHeight: '518.3px',
  },
  st1: {
    opacity: 0.5,
    enableBackground: 'new',
    fill: 'url(#sp_payment_1)',
  },
  st2: {
    opacity: 0.2,
    fill: '#fff',
    enableBackground: 'new',
  },
  st3: {
    opacity: 0.5,
    fill: 'url(#sp_payment_2)',
    enableBackground: 'new',
  },
  st4: {
    fill: '#fff',
  },
  st5: {
    fill: '#fcce09',
  },
  st7: {
    fill: '#452700',
  },
  st8: {
    fill: '#935e09',
  },
  st9: {
    fill: '#1e7a57',
  },
  st10: {
    fill: '#219d71',
  },
  st11: {
    fill: '#633e09',
  },
  st12: {
    fill: '#311900',
  },
})

export const WaitingForPayment: FC<SvgIconProps> = ({ viewBox = '0 0 753.3 518.3', ...props }) => {
  const { classes } = useStyles()

  return (
    <SvgIcon viewBox={viewBox} className={classes.st0} xmlns="http://www.w3.org/2000/svg" id="sp-payment" {...props}>
      <g className={classes.animation}>
        <linearGradient
          id="sp_payment_1"
          gradientUnits="userSpaceOnUse"
          x1="58.421"
          y1="420.538"
          x2="94.783"
          y2="349.174"
          gradientTransform="translate(0 -120.163)"
        >
          <stop offset=".269" stopColor="#1d1d1b" stopOpacity="0" />
          <stop offset=".511" stopColor="#181816" stopOpacity=".3645" />
          <stop offset=".817" stopColor="#080807" stopOpacity=".8249" />
          <stop offset=".933" stopColor="#000" />
        </linearGradient>
        <path className={classes.st1} d="m24.8 283.1 125-26.2-20.2-10.2-126 25.4z" />
        <path
          d="M104.2 98v136.1c0 14.4 12.7 24.5 27 22.8L378 213.8c11-1.7 18.6-11 18.6-22.8V54.9c0-14.4-12.7-24.5-27-22.8L122.8 75.2c-11 2.5-18.6 11.8-18.6 22.8z"
          className={classes.st9}
        />
        <path
          d="M108.4 101.4v136.1c0 14.4 12.7 24.5 27 22.8l246.8-43.1c11-1.7 18.6-11 18.6-22.8V59.1c0-14.4-12.7-24.5-27-22.8L127 79.4c-10.1 1.7-18.6 11-18.6 22z"
          className={classes.st10}
        />
        <path
          d="m374.7 36.3-142 24.5c2.5 79.4 69.3 136.1 151.3 127.6 5.9-.8 11.8-1.7 17.7-2.5V59.1c0-14.4-12.7-25.4-27-22.8z"
          className={classes.st2}
        />
        <path className={classes.st4} d="M132.1 223.1v6.7l110.7-19.4v-6.8z" />
        <path
          className={classes.st5}
          d="M167.6 130.1V97.3l-22.8 3.4c-6.8.8-12.7 5.9-12.7 11v.8l18.6-3.4 3.4-.8v34.5l-3.4.8v-10.1l-18.6 3.4v.8c0 5.1 5.9 8.5 12.7 6.8l33-5.1c6.8-.8 12.7-5.9 12.7-11v-.8l-18.6 3.4-4.3-.9z"
        />
        <path
          className={classes.st5}
          d="m150.7 122.5-18.6 3.4v7.6l18.6-2.6zM150.7 112.3l-18.6 3.4v7.6l18.6-3.3zM177.7 95.4l-5.9.8v10.1l18.6-3.4v-.8c0-5-5.9-7.5-12.7-6.7zM171 117.4l19.4-3.4v-7.6L171 109zM171 127.6l19.4-3.4v-7.6l-19.4 2.5z"
        />
        <g>
          <path
            className={classes.st4}
            d="M139.3 199c.9-.2 1.4-.2 2.3-.4.6-.1.8-.1 1 0 .3.2.5.5.5.8 0 .7-.5 1.2-1.5 1.4-2.7.5-4.1.7-6.8 1.2-.5.1-.8.1-1 0-.3-.2-.5-.5-.5-.8 0-.4.2-.8.5-1.1.2-.2.4-.2.9-.3.9-.2 1.4-.2 2.3-.4 0-3.7 0-5.5-.1-9.2-.8.3-1.2.5-1.9.9-.4.2-.5.2-.7.3-.6.1-1-.3-1-1s.3-1 1.2-1.4c1.9-.8 2.8-1.3 4.7-2.1 0 4.8 0 7.2.1 12.1zM154.1 196.3c0-.8.4-1.3 1.1-1.4.4-.1.8.1 1 .4.1.2.2.4.2.9 0 .8 0 1.2.1 2-4.1.7-6.2 1.1-10.3 1.8 0-.9 0-1.4-.1-2.4.1-.2.2-.2.4-.4 4.2-4.3 4.3-4.4 5.7-6.1 1.3-1.6 1.6-1.9 1.5-2.6 0-1.1-1.2-1.8-2.6-1.6-.9.2-1.7.6-2.1 1.3-.2.3-.2.4-.5 1.1-.1.4-.5.7-1 .8-.6.1-1.1-.3-1.1-.9 0-.7.5-1.9 1.3-2.8.9-1 2.1-1.6 3.4-1.9 2.7-.5 4.8 1 4.9 3.5.1 1.9-.4 2.7-6.2 8.7l-.2.2c1.8-.1 2.7-.3 4.5-.6zM165.3 187.9c1.1-.2 2-1.2 2-2.1-.1-1.1-1-1.5-2.6-1.3-1.3.2-1.8.6-2.5 1.5-.2.3-.5.4-.8.5-.6.1-1.1-.3-1.1-.9-.1-1.3 2.1-2.9 4.5-3.3 1.5-.3 2.7 0 3.5.7.7.6 1.2 1.5 1.2 2.4.1 1.2-.5 2.2-1.9 3.3 1.7.5 2.6 1.5 2.7 2.9.1 1.3-.5 2.7-1.5 3.6-.9.9-2.1 1.4-4.1 1.8-2.8.5-4.6.1-4.7-1.1 0-.6.5-1.2 1.1-1.3.3 0 .4 0 .7.1.6.3 1.3.3 2.7 0 1.6-.3 2.4-.6 3-1.3.4-.4.6-1 .6-1.5 0-.9-.7-1.5-1.8-1.8-.5-.1-.8-.1-1.7 0-.7.1-1.2-.2-1.2-.8 0-.7.4-1.2 1.1-1.3.3 0 .4 0 .8-.1zM176.6 185.4c.8-.4 1.5-.7 2.2-.8 2.7-.5 4.9 1.3 5 4.1.1 1.3-.3 2.5-1 3.5-.9 1.2-2.2 1.9-4.3 2.3-2.7.5-4.8-.1-4.9-1.4 0-.6.5-1.2 1.1-1.3.3-.1.5 0 .8.2.7.4 1.4.5 2.9.2 2.3-.4 3.4-1.4 3.3-3.2-.1-1.7-1.2-2.6-2.7-2.3-.7.1-1.7.6-2.7 1.2-.3.2-.4.2-.6.3-.7.1-1.2-.3-1.2-1.1-.1-2.5-.2-3.8-.4-6.3 2.7-.5 4.1-.7 6.8-1.2.6-.1.8-.1 1 0 .3.2.5.5.5.8 0 .4-.2.8-.5 1.1-.2.1-.5.2-.9.3-1.8.3-2.7.5-4.5.8 0 1.3 0 1.8.1 2.8zM210.7 185c.2 2.4-1.7 4.4-4.6 4.9-2.9.5-5-.8-5.2-3.2-.1-1.4.5-2.6 2-3.8-1.4-.7-2.1-1.5-2.2-2.7-.2-2.3 1.8-4.4 4.4-4.9 2.6-.4 4.8 1 5 3.2.1 1.2-.5 2.3-1.8 3.4 1.5.7 2.3 1.7 2.4 3.1zm-7.6 1.1c.1 1.2 1.2 1.8 2.8 1.5 1.5-.3 2.6-1.3 2.5-2.4s-1.3-1.8-2.8-1.6c-1.4.3-2.5 1.4-2.5 2.5zm-.2-6.3c.1 1.1 1.1 1.8 2.6 1.5 1.4-.2 2.4-1.2 2.3-2.3-.1-1.2-1.1-1.8-2.6-1.5-1.4.2-2.4 1.2-2.3 2.3zM220.6 184.7c.9-.2 1.4-.2 2.3-.4.6-.1.8-.1 1 0 .3.2.5.5.5.8.1.7-.4 1.2-1.4 1.4-2.7.5-4.1.7-6.8 1.2-.5.1-.8.1-1-.1-.3-.2-.5-.5-.5-.8 0-.4.2-.8.5-1.1.2-.2.4-.2.9-.3.9-.2 1.4-.2 2.3-.4-.3-3.7-.4-5.5-.7-9.1-.8.3-1.2.5-1.9.9-.4.2-.5.2-.7.3-.6.1-1.1-.3-1.1-1 0-.6.2-1 1.1-1.3 1.9-.8 2.8-1.2 4.7-2.1.3 4.8.4 7.2.8 12zM233 176.2c1.1-.2 2-1.2 1.9-2.1-.1-1.1-1.1-1.5-2.7-1.3-1.3.2-1.9.6-2.5 1.5-.2.3-.5.4-.8.5-.6.1-1.1-.3-1.2-.9-.1-1.3 2-2.9 4.5-3.3 1.5-.3 2.7 0 3.6.7.8.6 1.2 1.5 1.3 2.4.1 1.2-.4 2.2-1.9 3.3 1.8.5 2.7 1.5 2.8 3 .1 1.3-.5 2.7-1.4 3.6s-2.1 1.4-4.1 1.8c-2.8.5-4.7 0-4.7-1.1 0-.6.4-1.2 1.1-1.3.3 0 .4 0 .7.1.6.3 1.3.3 2.7.1 1.6-.3 2.4-.6 3-1.3.4-.4.6-1 .5-1.5-.1-.9-.8-1.5-1.9-1.8-.5-.1-.8-.1-1.8 0-.7.1-1.2-.2-1.2-.8 0-.6.4-1.2 1.1-1.3.4-.2.6-.2 1-.3zM249.1 179.9c0-.8.4-1.3 1.1-1.4.4-.1.8.1 1 .4.1.2.2.4.2.9.1.8.1 1.2.1 2-4.1.7-6.2 1-10.3 1.7-.1-.9-.1-1.4-.2-2.4.1-.2.2-.2.3-.4 4.1-4.3 4.2-4.4 5.6-6 1.3-1.6 1.5-1.9 1.5-2.6-.1-1.1-1.3-1.8-2.7-1.6-.9.2-1.7.6-2.1 1.3-.2.3-.2.4-.4 1.1-.1.4-.5.7-1 .8-.6.1-1.2-.3-1.2-.9 0-.7.5-1.9 1.2-2.7.9-1 2.1-1.6 3.5-1.9 2.8-.5 5 1 5.1 3.5.1 1.9-.4 2.7-6 8.6l-.2.2c1.7-.1 2.6-.3 4.5-.6zM274.9 175.6c.9-.2 1.4-.2 2.3-.4.6-.1.8-.1 1 0 .3.2.5.5.5.8 0 .7-.4 1.2-1.4 1.4-2.7.5-4.1.7-6.8 1.1-.5.1-.8.1-1-.1-.3-.2-.5-.5-.5-.8 0-.4.2-.8.5-1.1.2-.2.4-.2.9-.3.9-.2 1.4-.2 2.3-.4-.2-3.7-.3-5.5-.5-9.2-.8.3-1.2.5-2 .8-.4.2-.5.2-.7.3-.6.1-1.1-.3-1.1-1s.2-1 1.1-1.4c1.9-.8 2.9-1.2 4.8-2 .2 5 .4 7.5.6 12.3zM287.5 167.1c1.1-.2 2-1.2 2-2.1 0-1.1-1.1-1.6-2.6-1.3-1.3.2-1.9.6-2.6 1.5-.2.3-.5.4-.8.5-.6.1-1.1-.3-1.2-.9-.1-1.3 2.1-2.9 4.6-3.3 1.5-.3 2.7 0 3.6.7.7.6 1.2 1.5 1.2 2.4.1 1.2-.5 2.2-1.9 3.3 1.8.5 2.6 1.5 2.7 3 .1 1.3-.5 2.7-1.5 3.7-.9.9-2.1 1.4-4.1 1.8-2.8.5-4.6 0-4.7-1.2 0-.6.4-1.2 1.1-1.3.3 0 .4 0 .7.2.6.3 1.3.3 2.7.1 1.6-.3 2.4-.6 3-1.3.4-.4.6-1 .6-1.5 0-.9-.7-1.5-1.8-1.8-.5-.1-.8-.1-1.8 0-.7.1-1.2-.2-1.2-.8 0-.7.4-1.2 1.1-1.3.3-.3.5-.4.9-.4zM304.2 167.6c.9-.1 1.4.2 1.4.9s-.4 1.2-1.3 1.4v.9c.9-.1 1.4.2 1.4.9 0 .4-.2.8-.5 1.1-.2.1-.5.2-1 .3l-3 .5c-.5.1-.8.1-1-.1-.3-.2-.5-.5-.5-.8 0-.4.2-.8.5-1.1.2-.2.4-.2.9-.3.3-.1.5-.1.9-.1v-.9c-2.5.4-3.7.6-6.2 1 0-.8 0-1.1-.1-1.9 2-4 3.1-6 5.1-10l3-.5c.2 3.5.3 5.2.4 8.7zm-2.5-5.1c-1.3 2.4-1.9 3.6-3.2 6 1.4-.2 2-.3 3.4-.6 0-2.1-.1-3.2-.2-5.4zM312.6 162.4c.9-.4 1.6-.6 2.2-.8 2.8-.5 4.9 1.3 4.9 4.3 0 1.3-.4 2.6-1.2 3.6-1 1.3-2.3 1.9-4.4 2.3-2.7.5-4.8-.2-4.9-1.5 0-.6.5-1.2 1.1-1.3.3-.1.5 0 .8.2.7.5 1.4.5 2.9.3 2.4-.4 3.4-1.4 3.4-3.2 0-1.7-1.1-2.6-2.6-2.4-.7.1-1.7.6-2.7 1.2-.3.2-.4.2-.6.3-.7.1-1.2-.3-1.2-1.1-.1-2.6-.1-3.9-.2-6.4 2.8-.5 4.1-.7 6.9-1.1.6-.1.8-.1 1.1 0 .3.2.5.5.5.9s-.2.8-.5 1.1c-.2.1-.5.2-1 .3-1.8.3-2.8.5-4.6.8 0 .9 0 1.4.1 2.5zM339.9 157.9c.9-.4 1.6-.6 2.2-.8 2.8-.5 4.8 1.4 4.8 4.3 0 1.3-.4 2.6-1.2 3.6-1 1.3-2.3 1.9-4.4 2.3-2.7.5-4.8-.2-4.8-1.5 0-.6.5-1.2 1.1-1.3.3-.1.5 0 .8.2.7.5 1.3.5 2.8.3 2.4-.4 3.4-1.4 3.4-3.2 0-1.7-1.1-2.6-2.6-2.4-.7.1-1.7.6-2.7 1.2-.3.2-.4.2-.6.3-.7.1-1.1-.3-1.2-1.1 0-2.6-.1-3.9-.1-6.5 2.8-.5 4.1-.7 6.9-1.1.6-.1.8-.1 1.1 0 .3.2.5.5.5.9s-.2.8-.5 1.1c-.2.1-.5.2-1 .3-1.8.3-2.8.5-4.6.8 0 1 0 1.5.1 2.6zM360.3 160c0 2.4-2 4.4-4.9 4.9s-4.9-.9-4.9-3.3c0-1.4.7-2.7 2.2-3.9-1.4-.7-2-1.6-2-2.8 0-2.3 2-4.5 4.7-4.9 2.6-.4 4.7 1.1 4.8 3.3 0 1.3-.6 2.3-2 3.5 1.4.8 2.1 1.8 2.1 3.2zm-7.6 1.1c0 1.2 1.1 1.8 2.7 1.6 1.5-.3 2.6-1.3 2.6-2.4 0-1.2-1.2-1.9-2.7-1.6-1.4.2-2.6 1.3-2.6 2.4zm.2-6.4c0 1.2 1 1.8 2.5 1.6 1.4-.2 2.4-1.2 2.4-2.4s-1-1.8-2.5-1.6c-1.4.3-2.4 1.3-2.4 2.4zM369 157.1c-2.4.4-4.3-1.4-4.3-3.9 0-1.3.4-2.5 1.2-3.5.8-1 1.9-1.7 3.5-1.9 1.9-.3 3.3.2 4.1 1.6.6 1 1 2.7 1 4.3 0 2-.6 3.9-1.7 5.5-1.5 2.1-3.4 3.4-5.5 3.7-1.6.3-2.7-.2-2.7-1 0-.6.5-1.2 1.2-1.3.2 0 .4 0 .8.1.3.1.3.1.6 0 1.3-.2 2.5-1 3.5-2.3.8-1 1.2-1.9 1.5-3.3-1.2 1.3-2 1.8-3.2 2zm.2-7c-1.4.2-2.3 1.3-2.3 2.8 0 1.3 1 2.2 2.2 2 1-.2 2.1-1.1 2.7-2.4-.3-1.9-1.1-2.7-2.6-2.4zM383.7 157.6c.9-.2 1.4-.2 2.3-.4.6-.1.8-.1 1 0 .3.2.5.5.5.8 0 .7-.5 1.2-1.5 1.4-2.7.5-4.1.7-6.8 1.1-.5.1-.8.1-1-.1-.3-.2-.5-.5-.5-.8 0-.4.2-.8.5-1.1.2-.2.4-.2 1-.3.9-.2 1.4-.2 2.3-.4v-9.3c-.8.3-1.2.5-2 .8-.4.2-.5.2-.7.3-.6.1-1-.4-1-1 0-.7.3-1 1.2-1.4 1.9-.8 2.9-1.2 4.8-2-.1 5.1-.1 7.6-.1 12.4z"
          />
        </g>
        <path className={classes.st4} d="M309.6 83.6v6.8l62.5-11v-6.8z" />
      </g>
      <g id="Wallet">
        <linearGradient
          id="sp_payment_2"
          gradientUnits="userSpaceOnUse"
          x1="334.503"
          y1="445.912"
          x2="358.491"
          y2="398.834"
          gradientTransform="translate(0 -120.163)"
        >
          <stop offset=".269" stopColor="#1d1d1b" stopOpacity="0" />
          <stop offset=".511" stopColor="#181816" stopOpacity=".3645" />
          <stop offset=".817" stopColor="#080807" stopOpacity=".8249" />
          <stop offset=".933" stopColor="#000" />
        </linearGradient>
        <path className={classes.st3} d="m380.6 347.3 80.6-16.1L313 257.5l-81.4 16.1z" />
        <path
          className={classes.st7}
          d="m462.7 330.4 245.6-43.8L548.6 206c-.8-.8-2.3-.8-3.1-.8l-235.7 42.2c-5.4.8-6.1 7.7-1.5 10l142.8 71.4c3.2 2.4 7.8 2.4 11.6 1.6z"
        />
        <ellipse
          transform="rotate(-41.505 705.581 269.863)"
          className={classes.st7}
          cx="705.6"
          cy="269.9"
          rx="18.4"
          ry="16.9"
        />
        <path
          className={classes.st8}
          d="m462.7 323.5 241.8-43.8-155.8-80.6c-.8-.8-2.3-.8-3.8-.8l-235.7 42.2c-5.4.8-6.1 7.7-1.5 10l142.8 70.6c3.8 2.4 8.4 3.2 12.2 2.4z"
        />
        <ellipse
          transform="rotate(-41.505 704.216 267.387)"
          className={classes.st8}
          cx="704.2"
          cy="267.4"
          rx="13.1"
          ry="11.5"
        />
        <ellipse
          transform="rotate(-41.505 702.98 263.49)"
          className={classes.st7}
          cx="703"
          cy="263.5"
          rx="12.3"
          ry="11.5"
        />
        <path
          className={classes.st7}
          d="m465 318.2 239.5-43 .8-22.3-162.7-49.1-231.1 41.5 144.3 71.4c3.1 1.5 6.1 1.5 9.2 1.5z"
        />
        <path
          className={classes.st7}
          d="m462.7 302.8 247.2-44.5-159.7-79.1c-2.3-.8-4.6-1.5-6.9-.8l-234.1 42.2c-5.4.8-6.1 7.7-1.5 10l142.8 70.6c3.8 1.6 8.4 2.4 12.2 1.6z"
        />
        <path className={classes.st7} d="M305.3 218.4v7.6l143.6 74.5-1.6-8.4z" />
        <path
          className={classes.st8}
          d="m462.7 295.9 251-43-163.5-81.4c-2.3-.8-4.6-1.5-6.9-.8L309.2 213c-5.4.8-6.1 7.7-1.5 10l142.8 70.6c3.8 2.3 8.4 2.3 12.2 2.3z"
        />
        <path className="st7" d="m385.2 266.7 131.2-22.2-33.7-16.9-131.3 22.2z" />
        <path d="m385.2 261.3 131.2-22.2-34.5-16.9-130.5 22.3z" />
        <path
          className={classes.st5}
          d="M466.5 229.9c4.6-2.3 12.3-2.3 16.9 0s5.4 5.4.8 6.9c-4.6 2.3-12.3 2.3-16.9 0-5.4-1.6-5.4-4.6-.8-6.9z"
        />
        <path
          className={classes.st7}
          d="M312.2 245.2v-15.4L455 298.2s.8 20.7 1.5 19.2c.1-3.1-144.3-72.2-144.3-72.2zM516.4 239.1v5.4l-14.6-3.1z"
        />
        <path className={classes.st7} d="M389 262.9v34.5l-33.8-16.1-.7-35.3z" />
        <path className={classes.st11} d="M385.2 261.3V299l-33.8-16.9v-37.6z" />
        <path className={classes.st7} d="m385.2 299 13-3.1-13-.8z" />
      </g>
    </SvgIcon>
  )
}
